import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

const REQUEST_TAB_CHECKBOXES_WIDTH = 150;

export default makeStyles((theme: MuiTheme) => {
  const { widthDesktopDrawer, widthTabletDrawer } = theme;
  const { primary } = theme.palette;

  return {
    lastExamNoteContainer: {
      marginBottom: 12,
      padding: "0 8px 0 20px",
      wordBreak: "break-word",
      fontSize: 12,
      color: primary.main,
      lineHeight: "20px",
      width: `calc(100vw - ${REQUEST_TAB_CHECKBOXES_WIDTH}px)`,
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        width: `calc(100vw - ${widthTabletDrawer}px - ${REQUEST_TAB_CHECKBOXES_WIDTH}px)`
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        width: `calc(100vw - ${widthDesktopDrawer}px - ${REQUEST_TAB_CHECKBOXES_WIDTH}px)`
      }
    },
    lastExamNoteHeader: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap"
    },
    margin: {
      marginLeft: 4
    }
  };
});
